import { useSelector } from "react-redux";
import "./AdUsersHome.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import { FiSearch } from "react-icons/fi";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  LinearProgress,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import { GridLoader, ScaleLoader } from "react-spinners";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer.jsx";
import { FaUsers } from "react-icons/fa";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { MdAdd, MdClose, MdDelete, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { t } from "i18next";
import { CiImageOn } from "react-icons/ci";
import { IoIosRefresh } from "react-icons/io";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import { useNavigate } from "react-router-dom";
import { RiBuilding2Fill } from "react-icons/ri";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";

const AdUsersHome = () => {
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [branches, setBranches] = useState([]);
  const [currencyAction, setCurrencyAction] = useState("");
  const [templateView, setTemplateView] = useState("list");
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const [selectedRole, setSelectedRole] = useState(null);
  const [searchTermRole, setSearchTermRole] = useState("");
  const [showAddRoles, setShowAddRoles] = useState(false);
  const [systemRoles, setSystemRoles] = useState([]);

  // notes on user creation
  const [isErrorsDialogOpen, setIsErrorsDialogOpen] = useState(false);
  const [errorDialogTitle, setErrorDialogTitle] = useState("Note");
  const [createUserErrors, setCreateUserErrors] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["users-reports"]);

  // reports
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

  const handleErrorsCloseDialog = () => {
    setIsErrorsDialogOpen(false);
  };

  const handleUploadDoalogClose = () => {
    setIsUploadDialogOpen(false);
  };


  const handleSearchUsers = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/adUser/search", { search_input: searchTerm });
      setUsers(res.data);
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/adUser/findAll", { result_limit: 3 });
      setUsers(res.data);
      setCurrencyAction("viewUser");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredUsers = users?.filter(
    (item) =>
      item?.usr_un?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.usr_full_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.usr_email?.toLowerCase().includes(searchTerm?.toLowerCase())
  );


  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="ad-users-home">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="ad-users-home-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <span className="page-title">{t('users')?.toUpperCase()}</span>
              <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<IoIosRefresh />}
                  onClick={async () => await fetchUsers()}
                >
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run user reports"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0ea5a4"
                  tooltip={"Add new user"}
                  endIcon={<MdAdd />}
                  onClick={() => navigate("/user/new")}
                >
                  {t('newUser')}
                </CustomLoadingButton>
              </div>
            </div>
            <div className="list-content">
              <FaUsers className="icon" />
              <h1 className="all-hero-title">{t('applicationUsers')}</h1>
              <p className="all-hero-sub">{t('applicationUsersDesc')}</p>
              {/* Search */}
              <div className="homeSearch">
                <FiSearch className="homeSearchIcon" />
                <input
                  className="homeSearchInput"
                  type="text"
                  placeholder={`${t('search')} ${t('users')}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSearchUsers();
                  }}
                />
                {searchTerm?.length > 0 ? (
                  <MdClose
                    className="homeSearchClear"
                    onClick={() => {
                      try {
                        fetchUsers();
                        setSearchTerm("");
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                ) : (
                  <span className="homeSearchClearPlaceholder" />
                )}
              </div>
              <div className="cards-wrapper">
                {filteredUsers.map((row) => (
                  <div className="single-card"
                    key={row?._id}
                    onClick={() => navigate(`/user/${row?._id}`)}
                  >
                    <div className="single-card-top">
                      <div className="single-card-top-left">
                        {row?.usr_photo_url && <img
                          src={row?.usr_photo_url}
                          alt=""
                          className="img"
                        />}
                        {!row?.usr_photo_url &&
                          <InitialsAvatar
                            name={row?.usr_full_name}
                            size={60}
                            currentTheme={currentTheme}
                          />}
                      </div>
                      <div className="single-card-top-right">
                        <span className="user-full-name">{row?.usr_full_name && row.usr_full_name.length > 200
                          ? row.usr_full_name.slice(0, 20) + "..."
                          : row?.usr_full_name}</span>
                        <span className="user-type">{`${row?.profile_name_xx}`}</span>
                      </div>
                    </div>
                    <div className="single-card-center">
                      <div className="single-card-center-row">
                        <span className="user-title">{t('type')}</span>
                        <span className="user-title">{t('enabled')}</span>
                      </div>
                      <div className="single-card-center-row">
                        <span className="user-title-value">{row?.user_type_xx}</span>
                        <span className="user-title-value">{row?.usr_enabled === "Y" ? t('yes').toUpperCase() : t('no').toUpperCase()}</span>
                        {/* <span className={`status ${row?.ent_status}`}>{row?.ent_status}</span> */}
                      </div>
                      <div className="single-card-center-col">
                        <div className="email-phone-row">
                          <MdPhone className="icon" /> <span>{row?.usr_phone_no}</span>
                        </div>
                        <div className="email-phone-row">
                          <MdEmail className="icon" /> <span>{row?.usr_email}</span>
                        </div>
                        <div className="email-phone-row">
                          <RiBuilding2Fill className="icon" /> <span>{row?.bizunit_name_xx}</span>
                        </div>
                      </div>
                    </div>
                    <div className="single-card-bottom">
                      <WorkedOnBy name={row?.updated_by_name_xx} photoUrl={row?.updated_by_photo_url_xx} time_ago_xx={row?.time_ago_xx} />
                    </div>
                  </div>
                ))}
              </div>
              <div className="list-footer">
                <button className="overlay-button" onClick={() => setIsOverlayOpen(true)}>
                  {t('how')}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
      {/* errors on user creation*/}
      <Dialog open={isErrorsDialogOpen} onClose={() => setIsErrorsDialogOpen(false)}>
        <DialogTitle>{errorDialogTitle}</DialogTitle>
        <DialogContent>
          {createUserErrors.map((row, index) => (
            <div
              key={row?._id}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginRight: "5px",
                  }}
                >
                  {index + 1}.
                </span>
                <span dangerouslySetInnerHTML={{ __html: row?.text }} />
              </div>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={handleErrorsCloseDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: selectedUser.usr_un,
                  docType: "User",
                  docId: selectedUser?._id,
                  username: selectedUser?.usr_un,
                  userFullName: selectedUser?.usr_full_name,
                  userEmail: selectedUser?.usr_email,
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {showAddRoles && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('roles').toUpperCase()}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setShowAddRoles(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="table-content" style={{ width: "600px" }}>
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                          <div className="search-input-wrapper" style={{ width: "90%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={t('search')}
                              value={searchTermRole}
                              onChange={(e) => setSearchTermRole(e.target.value)}
                            />
                            {searchTermRole.length > 0 && (
                              <MdClose
                                onClick={(e) => setSearchTermRole("")}
                                className="search-input-icon"
                              />
                            )}
                            {searchTermRole.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                          <span>{t('action').toUpperCase()}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {systemRoles
                        ?.filter(
                          (row) =>
                            row?.role_code.toLowerCase().includes(searchTermRole.toLowerCase()) ||
                            row?.role_name.toLowerCase().includes(searchTermRole.toLowerCase())
                        )
                        .map((row, index) => (
                          <TableRow
                            key={row?._id}
                            className={`${selectedRole?._id === row._id ? "tablerow current" : "tablerow"}`}
                            onClick={async () => {
                              try {
                                setSelectedRole(row);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="normal-title">{index + 1}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                              <h1 className="sub-title">{row?.role_name}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>

                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {isOverlayOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>{t('help').toUpperCase()}</span>
              <CircularButton onClick={() => setIsOverlayOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <VideoPlayer videoUrl="https://www.youtube.com/embed/PPCfDe8TfJQ" />
            </div>
            <div className="overlay-actions">
            </div>
          </div>
        </motion.div>
      )}
      {/* progress dialog for file upload  */}
      <UploadDialog
        open={isUploadDialogOpen}
        handleClose={handleUploadDoalogClose}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};

const UploadDialog = ({ open, handleClose, uploadProgress }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Progress</DialogTitle>
      <DialogContent>
        <LinearProgress variant="determinate" value={uploadProgress} />
        {uploadProgress && <p>{uploadProgress}% Complete</p>}
      </DialogContent>
    </Dialog>
  );
};

export default AdUsersHome;
